import type { GetGradeDescriptionsResponse } from './grade-descriptions'

export const getGradeDescriptionsMock: GetGradeDescriptionsResponse = [
  {
    backboxGrade: { name: 'Fair', value: 12 },
    paragraphs: [
      {
        title: "How it'll look:",
        tag: 'Fair',
        texts: [
          'Screen: May have micro-scratches which could be slightly noticeable when the screen is turned on',
          'Body: Has visible scratches and/or dents',
        ],
      },
      {
        title: 'Technical condition:',
        tag: 'Fair',
        tooltip: [
          'Only great items are sold on Back Market. To help you choose, the condition rating includes the seller’s quality and refurbishment processes. All sellers are vetted, evaluated, and monitored by us.',
        ],
        texts: [
          'Every device is guaranteed to be 100% functional, regardless of its cosmetic grade.',
        ],
        link: {
          text: 'Learn more',
          url: 'https://www.backmarket.com/en-us/about-us',
        },
      },
    ],
    images: [
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_eco_1-min.jpg',
        alt: 'Picture image_1 for Smartphones in condition: "Fair"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_eco_2-min.jpg',
        alt: 'Picture image_2 for Smartphones in condition: "Fair"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_eco_3-min.jpg',
        alt: 'Picture image_3 for Smartphones in condition: "Fair"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_eco_4-min.jpg',
        alt: 'Picture image_4 for Smartphones in condition: "Fair"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_eco_5-min.jpg',
        alt: 'Picture image_5 for Smartphones in condition: "Fair"',
      },
    ],
  },
  {
    backboxGrade: { name: 'Good', value: 11 },
    paragraphs: [
      {
        title: "How it'll look:",
        tag: 'Good',
        texts: [
          'Screen: Perfect condition',
          'Body: May have micro-scratches visible from 8 inches away',
        ],
      },
      {
        title: 'Technical condition:',
        tag: 'Good',
        tooltip: [
          'Only great items are sold on Back Market. To help you choose, the condition rating includes the seller’s quality and refurbishment processes. All sellers are vetted, evaluated, and monitored by us.',
        ],
        texts: [
          'Every device is guaranteed to be 100% functional, regardless of its cosmetic grade.',
        ],
        link: {
          text: 'Learn more',
          url: 'https://www.backmarket.com/en-us/about-us',
        },
      },
    ],
    images: [
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_verygood_1-min.jpg',
        alt: 'Picture image_1 for Smartphones in condition: "Good"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_verygood_2-min.jpg',
        alt: 'Picture image_2 for Smartphones in condition: "Good"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_verygood_3-min.jpg',
        alt: 'Picture image_3 for Smartphones in condition: "Good"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_verygood_4-min.jpg',
        alt: 'Picture image_4 for Smartphones in condition: "Good"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_verygood_5-min.jpg',
        alt: 'Picture image_5 for Smartphones in condition: "Good"',
      },
    ],
  },
  {
    backboxGrade: { name: 'Excellent', value: 10 },
    paragraphs: [
      {
        title: "How it'll look:",
        tag: 'Excellent',
        texts: [
          'Screen: Perfect condition',
          'Body: May have barely visible micro-scratches, not noticeable from 8 inches away',
        ],
      },
      {
        title: 'Technical condition:',
        tag: 'Excellent',
        tooltip: [
          'Only great items are sold on Back Market. To help you choose, the condition rating includes the seller’s quality and refurbishment processes. All sellers are vetted, evaluated, and monitored by us.',
        ],
        texts: [
          'Every device is guaranteed to be 100% functional, regardless of its cosmetic grade.',
        ],
        link: {
          text: 'Learn more',
          url: 'https://www.backmarket.com/en-us/about-us',
        },
      },
    ],
    images: [
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_flawless_1-min.jpg',
        alt: 'Picture image_1 for Smartphones in condition: "Excellent"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_flawless_2-min.jpg',
        alt: 'Picture image_2 for Smartphones in condition: "Excellent"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_flawless_3-min.jpg',
        alt: 'Picture image_3 for Smartphones in condition: "Excellent"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_flawless_4-min.jpg',
        alt: 'Picture image_4 for Smartphones in condition: "Excellent"',
      },
      {
        url: 'https://d28i4xct2kl5lp.cloudfront.net/product_page/images/smartphone_flawless_5-min.jpg',
        alt: 'Picture image_5 for Smartphones in condition: "Excellent"',
      },
    ],
  },
]
